var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"page","role":"main"}},[_c('div',{attrs:{"id":"frame-container"}},[(_vm.moduleData)?_c('iframe',{ref:"iframe",attrs:{"title":_vm.moduleData.name,"src":_vm.moduleData.url}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }